import {
  getYourBenchmarkSummaryData,
  AddErrorComments,
  getSurveyErrorsSummary,
  validateAdminOnly,
  submitSurvey,
  getPreviousYearValue,
  getPreviousYearValueForPanel,
  saveInputValuePABS,
  AddAnalystComments,
  changeSurvey,
  validateSurvey,
  getAvailableSurveys,
  getAccountInfo,
  getPabsSurveyList,
  unlockSurvey,
  changeSurveyCleaner,
  changeSurveyStatus,
  getExcelTemplatePabs,
  getHelpFilePabs,
  getActivityDefsFilePabs,
  getAvailablePlansPabs,
  getAvailableSurveysForAllPABSPlans,
  setLastWorkedOnOrg,
  getPageErrors,
} from './Services/PABS/PabsService'
import {
  getIbsAccountInfo,
  getTableData,
  makeAssetMandateMapping,
  getMandateStyles,
  getAssetClasses,
  saveInputValueDC,
  insertEmptyRow,
  AddErrorCommentsByIdDC,
  getAvailableSurveysIBS,
  changeSurveyIBS,
  validateDCSurvey,
  submitDCSurvey,
  unlockDCSurvey,
  deleteRowFromTableDC,
  updateSurveyInfo,
  updatePlanInfo,
  getExcelTemplateIbs,
  getHelpFileIbs,
  getSurveyCleaners,
  getSurveyLaundromatList,
  getTemplateData,
  GetProductStatsDB,
  GetProductStatsDC,
  secretValidateDC,
  secretValidateDB,
  secretRulesRefresh,
  clearErrors,
  getSurveyHistoricalSurveys,
  getPageErrorsDC,
  GetRecentActivityList,
  GetSurveySubmissionsByDate,
  getDCResultsParticipant,
  getDCResultsUniverse,
  getOptionsModalDefaults,
  getDropdownOptions,
  getPlanAvailableSurveysIBS,
  getAvailableSurveysForAllIBSPlans,
  getAvailablePlans,
  checkIfAnalyst,
  setAnalystInfo,
    initialMorningstarMatch,
} from './Services/IBS/IbsService'
import {
  getAssetCategories,
  getTableDataDb,
  addRowToTable,
  saveInputValueDB,
  getAssetStylesByCategory,
  deleteRowFromTable,
  AddErrorCommentsByIdDB,
  GetAssetStylesDB,
  GetDefaultCosts,
  getDataYear,
  validateDBSurvey,
  submitDBSurvey,
  unlockDBSurvey,
  UpdateMandateInfo,
  SetCultureFromSurvey,
  deleteMandate,
  hasBundledLDIAssets,
  changeDBSurveyCleaner,
  changeDBSurveyCleanerID,
  changeDBSurveyCleanerFields,
  changeDBSurveyStatus,
  addBenchmarkPolicy,
  AddMandateRow,
  UpdateMandateInfoSingle,
  getParticipantResult,
  getUniverseResult,
  getMandateSubstyles,
  getMandateRegions,
  getPageErrorsDB,
} from './Services/IBS/DbService'
import store from './components/Stores/SurveyStore'
import ibsStore from './components/Stores/IbsSurveyStore'
import sharedStore from './components/Stores/SharedStore'
import {
  CURRENT_DATA_YEAR,
  PABS_CURRENT_DATA_YEAR, 
  PabsProductID,
  SurveyTypeURL,
} from './Enums/constants'
import UserStore from './components/Stores/UserStore'
import { DbSortFunctionForAssets } from './ibsHelper'

const loadCommonData = async () => {
  await getDataYear()
  await getIbsAccountInfo()
  await getAvailablePlans()
  await getAvailableSurveysForAllPlansIBS()

  getAnalystOnlyData()

  await getDropdownOptions('ENHANCED_SURVEY_OPTIONS')
  await getMandateSubstyles()
  await getMandateRegions()
}
export async function getAnalystOnlyData() {
  if (checkIfAnalyst()) {
    await Promise.all([
      getSurveyCleaners(),
      getSurveyHistoricalSurveys(),
      getSurveyLaundromatList(),
      GetRecentActivityList(),
      GetProductStatsDB(),
      GetProductStatsDC(),
      GetSurveySubmissionsByDate(),
    ]).catch((error) => {
      console.error(error.message)
    })
  }
}
export async function LoadIBSView() {
  setAnalystInfo()

  await loadCommonData()

  await Promise.all([
    await hasBundledLDIAssets(),
    await getIBSPlanResults(),
  ]).catch((error) => {
    console.error(error.message)
  })
  let defaultPlanID3 = store.availablePlanProducts[0]?.PlanId //check cache???
  await getAvailableSurveysIBS(0, defaultPlanID3)
}

export async function LoadDBSurvey() {
  setAnalystInfo()
  let lastOpenedDbSurveyId = localStorage.getItem('lastOpenedSurveyIdCacheDB')
  if (typeof lastOpenedDbSurveyId === 'string' && lastOpenedDbSurveyId !== '') {
    await SetCultureFromSurvey(lastOpenedDbSurveyId)
  }
  await loadCommonData()
  await Promise.all([getAssetCategories(), GetSurveySubmissionsByDate()]).catch(
    (error) => {
      console.error(error.message)
    }
  )

  let defaultPlanIDforUser = localStorage.getItem('lastOpenedPlanID')
  if (!defaultPlanIDforUser)
    defaultPlanIDforUser = store.availablePlanProducts[0]?.PlanId

  await getAvailableSurveysIBS(0, defaultPlanIDforUser, 'DB')

  await Promise.all([
    getTemplateData(),
    hasBundledLDIAssets(),
    getIBSPlanResults(),
    getAllIBSDropDownOptions(),
  ]).catch((error) => {
    console.error(error.message)
  })
}

export async function LoadDCSurvey() {
  setAnalystInfo()
  let lastOpenedDcSurveyId = localStorage.getItem('lastOpenedSurveyIdCacheDC')

  if (typeof lastOpenedDcSurveyId === 'string' && lastOpenedDcSurveyId !== '') {
    await SetCultureFromSurvey(lastOpenedDcSurveyId)
  }

  await initialMorningstarMatch(lastOpenedDcSurveyId)

  await loadCommonData()

  let defaultPlanIDforUser = localStorage.getItem('lastOpenedPlanID')
  if (!defaultPlanIDforUser)
    defaultPlanIDforUser = store.availablePlanProducts[0]?.PlanId
  await getAvailableSurveysIBS(0, defaultPlanIDforUser, 'DC')

  await Promise.all([getIBSPlanResults(), getAllIBSDropDownOptions()]).catch(
    (error) => {
      console.error(error.message)
    }
  )
}

export async function LoadPABSSurvey() {
  sharedStore.currentDataYear =
    store.isPabsSurvey
      ? PABS_CURRENT_DATA_YEAR
      : CURRENT_DATA_YEAR

  await getAccountInfo()
  await getAvailablePlansPabs()
  await getAvailableSurveysForAllPlansPABS()

  // Check if coming from laundromat navigation
  const selectedPabsSurveyId = localStorage.getItem('selectedPabsSurveyId')
  const selectedPabsSystemId = localStorage.getItem('selectedPabsSystemId')
  const selectedPabsDataYear = localStorage.getItem('selectedPabsDataYear')

  let defaultPlanIDforUser = 0
  let defaultSurveyTypePabs = 0
  let targetSurveyId = null

  if (selectedPabsSurveyId && selectedPabsSystemId) {
    // Coming from laundromat - use the selected survey
    defaultPlanIDforUser = parseInt(selectedPabsSystemId)
    targetSurveyId = parseInt(selectedPabsSurveyId)
    
    // Clear the localStorage values after use
    localStorage.removeItem('selectedPabsSurveyId')
    localStorage.removeItem('selectedPabsSystemId')
    localStorage.removeItem('selectedPabsDataYear')
  } else {
    // Normal flow - use last worked on organization
    const lastOpenedOrgIdCache = UserStore.accountInfo.orgIdLastWorkedOn
    const existsInPlansList = store.availablePlanProducts.some(
      (obj) => obj.PlanId === lastOpenedOrgIdCache
    )

    if (
      lastOpenedOrgIdCache > 0 &&
      ((existsInPlansList && !UserStore.accountInfo.isAnalyst) ||
        UserStore.accountInfo.isAnalyst)
    ) {
      defaultPlanIDforUser = lastOpenedOrgIdCache
      defaultSurveyTypePabs = 0
    } else {
      localStorage.clear()
      defaultPlanIDforUser = store.availablePlanProducts[0]?.PlanId
      defaultSurveyTypePabs = store.availablePlanProducts[0]?.DefaultSurveyTypeId
      await setLastWorkedOnOrg(defaultPlanIDforUser)
    }
  }

  await getAvailableSurveys(defaultPlanIDforUser)
  await getPabsSurveyList()

  if (
    store.availableSurveys != null &&
    store.availableSurveys.length > 0
  ) {
    // Use the target survey from laundromat or default to first available
    const surveyToLoad = targetSurveyId && store.availableSurveys.find(s => s.SurveyId === targetSurveyId)
      ? targetSurveyId
      : store.availableSurveys[0]['SurveyId']

    await changeSurveyCtrl(surveyToLoad, defaultPlanIDforUser)
    await setLastWorkedOnOrg(defaultPlanIDforUser)

    // TODO PABS: use non localstorage for navigation.js
    localStorage.removeItem('lastOpenedSurveyTypeIdCache')
    localStorage.setItem(
      'lastOpenedSurveyTypeIdCache',
      store?.currentSurvey?.SurveyTypeId
    )

    // TODO PABS: rewrite this block
    // Don't redirect if we're on a laundromat page
    if (!window.location.href.includes('/laundromat')) {
      if (
        store?.currentSurvey?.SurveyTypeId === PabsProductID.PabsWorld &&
        !window.location.href.includes('/pabs/')
      ) {
        window.location.replace('/pabs/home')
      }
      if (
        store?.currentSurvey?.SurveyTypeId === PabsProductID.PabsUK &&
        !window.location.href.includes('/pabsuk/')
      ) {
        window.location.replace('/pabsuk/home')
      }
      if (
        store?.currentSurvey?.SurveyTypeId === PabsProductID.PabsLG &&
        !window.location.href.includes('/pabslg/')
      ) {
        window.location.replace('/pabslg/home')
      }
    }
  }
}

export const checkTermsSigned = () => {
  // if terms and conditions are signed are agreed or it is a historical data year or, give access
  return (
    ibsStore.currentSurvey.isAgreed ||
    ibsStore.currentSurvey.DataYear < CURRENT_DATA_YEAR ||
    checkIfAnalyst()
  )
}

export function getAvailableSurveysForAllPlansIBS() {
  store.allAvailableSurveys = []
  const uniquePlans = [
    ...new Map(
      store.availablePlanProducts.map((item) => [item.PlanId, item])
    ).values(),
  ]
  uniquePlans.forEach((plan) => {
    getAvailableSurveysForAllIBSPlans(plan.PlanId)
  })
}

export async function getAvailableSurveysForAllPlansPABS() {
  store.allAvailableSurveys = []
  const uniquePlans = [
    ...new Map(
      store.availablePlanProducts.map((item) => [item.PlanId, item])
    ).values(),
  ]

  let promiseList = []
  uniquePlans.forEach((plan) => {
    promiseList.push(getAvailableSurveysForAllPABSPlans(plan.PlanId))
  })

  await Promise.all(promiseList)
}

export function getAllDBDropDownOptions() {
  getDropdownOptions('ENHANCED_SURVEY_OPTIONS')
}
export function getAllIBSDropDownOptions() {
  getDropdownOptions('ENHANCED_SURVEY_OPTIONS')
  getDropdownOptions('ASSET_RETURN_TYPES')
}
export async function getAllTableData() {
  getTableData('Options')
  getTableData('Benchmarks')
  getTableData('TDBalancedFunds')
  getTableData('PercentPassive')
  getTableData('AssetAllocation')
  await getMandateStyles()
  await getAssetClasses()
  makeAssetMandateMapping()
}

export async function getAllTableDataDB(surveyIdOverride) {
  await Promise.all([
    getTableDataDb('Stock', true, surveyIdOverride),
    getTableDataDb('FixedIncome', true, surveyIdOverride),
    getTableDataDb('RealAssets', true, surveyIdOverride),
    getTableDataDb('HedgeFund', true, surveyIdOverride),
    getTableDataDb('PrivateEquityAsset', true, surveyIdOverride),
    getTableDataDb('PrivateDebt', true, surveyIdOverride),
    getTableDataDb('Derivatives', true, surveyIdOverride),
  ])
    .then((result) => {
      if (
        surveyIdOverride &&
        surveyIdOverride != store.currentSurvey.SurveyID
      ) {
        //grabbing last years data for reference
        ibsStore.lyAssetData['combinedAssets'] = ibsStore.lyAssetData['Stock']
          .concat(ibsStore.lyAssetData['FixedIncome'])
          .concat(ibsStore.lyAssetData['RealAssets'])
          .concat(ibsStore.lyAssetData['HedgeFund'])
          .concat(ibsStore.lyAssetData['PrivateEquityAsset'])
          .concat(ibsStore.lyAssetData['PrivateDebt'])
          .concat(ibsStore.lyAssetData['Derivatives'])
      } else {
        //for this current survey
        ibsStore.allTableResponses['combinedAssets'] =
          ibsStore.allTableResponses['Stock']
            .concat(ibsStore.allTableResponses['FixedIncome'])
            .concat(ibsStore.allTableResponses['RealAssets'])
            .concat(ibsStore.allTableResponses['HedgeFund'])
            .concat(ibsStore.allTableResponses['PrivateEquityAsset'])
            .concat(ibsStore.allTableResponses['PrivateDebt'])
            .concat(ibsStore.allTableResponses['Derivatives'])
            .sort(DbSortFunctionForAssets)
      }
    })
    .catch((reason) => {
      console.error(`getTableDataDb multi promise error: ${reason}`)
    })

  await getTableDataDb('Benchmark', false) //this was creating 'blank rows'
  await getTableDataDb('CustomGroupings', false) //this was creating 'blank rows'

  await getTableDataDb('Expenses')
  await getTableDataDb('PrivateEquity')
}

export function addErrorCommentsCtrl() {
  switch (store.surveyTypeUrl) {
    case SurveyTypeURL.PABS_LG:
    case SurveyTypeURL.PABS_UK:
    case SurveyTypeURL.PABS:
      AddErrorComments(
        store.errorCommentContent.QuestionName,
        store.errorCommentContent.TempErrorExplanation
      )
      break
    case SurveyTypeURL.DC:
      if (store.errorCommentContent.ErrorId === '') {
        console.error('ADDING VIA NON ID (DC)')
      } else {
        AddErrorCommentsByIdDC(
          store.errorCommentContent.ErrorId,
          store.errorCommentContent.TempErrorExplanation,
          store.errorCommentContent.RowID
        )
      }

      break
    case SurveyTypeURL.DB:
      if (
        typeof store.errorCommentContent.ErrorId === 'undefined' ||
        store.errorCommentContent.ErrorId == null
      ) {
        console.error('ADDING VIA NON ID (DB)')
      } else {
        AddErrorCommentsByIdDB(
          store.errorCommentContent.ErrorId,
          store.errorCommentContent.TempErrorExplanation
        )
      }

    default:
      break
  }
}

export function validateSurveyCrtl() {
  store.loadingErrorSummaryDone = false
  //check if ibs or pabs
  if (
    store.surveyTypeUrl == SurveyTypeURL.PABS ||
    store.surveyTypeUrl == SurveyTypeURL.PABS_UK ||
    store.surveyTypeUrl === SurveyTypeURL.PABS_LG
  ) {
    validateSurvey()
  } else if (store.surveyTypeUrl == SurveyTypeURL.DC) {
    validateDCSurvey()
  } else if (store.surveyTypeUrl == SurveyTypeURL.DB) {
    validateDBSurvey()
  }
}

export function secretRulesRefreshCtrl() {
  secretRulesRefresh()
}

export function clearErrorsCtrl(surveyId) {
  clearErrors(surveyId)
}

export async function secretValidateCtrl() {
  if (
    store.surveyTypeUrl == SurveyTypeURL.PABS ||
    store.surveyTypeUrl == SurveyTypeURL.PABS_UK ||
    store.surveyTypeUrl === SurveyTypeURL.PABS_LG
  ) {
    return
  } else if (store.surveyTypeUrl == SurveyTypeURL.DC) {
    await secretValidateDC()
  } else if (
    store.surveyTypeUrl == SurveyTypeURL.DB ||
    store.surveyTypeUrl == SurveyTypeURL.IBS
  ) {
    await secretValidateDB()
  }
}

export function validateAdminOnlyCtrl(lang) {
  validateAdminOnly()
}

export function submitSurveyCtrl() {
  //check if ibs or pabs
  if (
    store.surveyTypeUrl == SurveyTypeURL.PABS ||
    store.surveyTypeUrl == SurveyTypeURL.PABS_UK ||
    store.surveyTypeUrl === SurveyTypeURL.PABS_LG
  ) {
    submitSurvey()
  } else if (store.surveyTypeUrl == SurveyTypeURL.DC) {
    submitDCSurvey()
  } else if (store.surveyTypeUrl == SurveyTypeURL.DB) {
    submitDBSurvey()
  }
}

export function unlockSurveyCtrl() {
  //check if ibs or pabs
  if (
    store.surveyTypeUrl == SurveyTypeURL.PABS ||
    store.surveyTypeUrl == SurveyTypeURL.PABS_UK ||
    store.surveyTypeUrl === SurveyTypeURL.PABS_LG
  ) {
    unlockSurvey()
  } else if (store.surveyTypeUrl == SurveyTypeURL.DC) {
    unlockDCSurvey()
  } else if (store.surveyTypeUrl == SurveyTypeURL.DB) {
    unlockDBSurvey()
  }
}

// TODO This will never fire, accountInfo is in userStore not store.
// Either fix or delete altogether.
export function getSurveyErrorSummaryCtrl(lang) {
  if (store.accountInfo) getSurveyErrorsSummary(lang)
}

export async function getPageErrorsCtrl(page) {
  if (
    store.surveyTypeUrl === SurveyTypeURL.PABS ||
    store.surveyTypeUrl === SurveyTypeURL.PABS_UK ||
    store.surveyTypeUrl === SurveyTypeURL.PABS_LG
  ) {
    await getPageErrors(page)
  } else if (store.surveyTypeUrl === SurveyTypeURL.DC) {
    await getPageErrorsDC(page)
  } else if (store.surveyTypeUrl === SurveyTypeURL.DB) {
    await getPageErrorsDB(page)
  }
}

export async function changeSurveyCtrl(surveyId, orgId, productId = null) {
  switch (store.surveyTypeUrl) {
    case SurveyTypeURL.PABS_LG:
    case SurveyTypeURL.PABS_UK:
    case SurveyTypeURL.PABS:
      await changeSurvey(surveyId, orgId)
      break
    case SurveyTypeURL.IBS:
    case SurveyTypeURL.DB:
    case SurveyTypeURL.DC:
      await changeSurveyIBS(surveyId, orgId, productId)
      break
    default:
      break
  }
}
export async function getExcelTemplateCtrl() {
  switch (store.surveyTypeUrl) {
    case SurveyTypeURL.PABS_LG:
    case SurveyTypeURL.PABS_UK:
    case SurveyTypeURL.PABS:
      await getExcelTemplatePabs()
      break

    case SurveyTypeURL.IBS:
    case SurveyTypeURL.DB:
    case SurveyTypeURL.DC:
      await getExcelTemplateIbs()
      break

    default:
      break
  }
}

export async function getHelpFileCtrl() {
  switch (store.surveyTypeUrl) {
      case SurveyTypeURL.PABS_LG:
      case SurveyTypeURL.PABS_UK:
      case SurveyTypeURL.PABS:
      await getHelpFilePabs()
      break

    case SurveyTypeURL.IBS:
    case SurveyTypeURL.DB:
    case SurveyTypeURL.DC:
      await getHelpFileIbs()
      break

    default:
      break
  }
}

//can add other definition files 
export async function getActivityDefsFileCtrl() {
  switch (store.surveyTypeUrl) {
    case SurveyTypeURL.PABS:
    case SurveyTypeURL.PABS_LG:
    case SurveyTypeURL.PABS_UK:
      await getActivityDefsFilePabs()
      break

    default:
      break
  }
}

export function getLastYearValue(inputName) {
  getPreviousYearValue(inputName)
}

export function openPrevYearPanel(questionName) {
  const isPabs = [SurveyTypeURL.PABS, SurveyTypeURL.PABS_UK, SurveyTypeURL.PABS_LG].includes(store.surveyTypeUrl)
  if (!isPabs) return
  if (!questionName) return

  store.prevYearPanel.name = questionName
  store.prevYearPanel.value = null
  store.prevYearPanel.visible = true
  getPreviousYearValueForPanel(questionName)
}

/**
 * This is the improved saveValue that accepts a parameter that can be different for pabs and ibs
 * @param inputName the value identifier of some kind
 * @param value the value to save
 * @param extraProps extra properties that contains the metadata needed to save properly
 * @returns {undefined|Promise<*|void>}
 */
export const saveValueNew = (inputName, value, extraProps) => {
  switch (store.surveyTypeUrl) {
    case SurveyTypeURL.PABS_LG:
    case SurveyTypeURL.PABS_UK:
    case SurveyTypeURL.PABS:
      const inputStateId = extraProps?.inputStateId;
      saveInputValuePABS(inputName, value, inputStateId)
      return undefined

    case SurveyTypeURL.DB: {
      const tableName = extraProps?.tableName;
      const rowId = extraProps?.rowId;
      return saveInputValueDB(inputName, value, tableName, rowId)
    }
    
    case SurveyTypeURL.DC: {
      const tableName = extraProps?.tableName;
      const rowId = extraProps?.rowId;
      saveInputValueDC(inputName, value, tableName, rowId)
      return undefined
    }

    default:
      return undefined
  }
}

export function insertEmptyRowCtrl(tableName) {
  insertEmptyRow(tableName)
  //remove later
}
export function autoPopOptionsModal() {
  getOptionsModalDefaults()
}

export function addAnalystComment() {
  AddAnalystComments(
    store.commentAnalystContent.QuestionName,
    store.commentAnalystContent.TempComment
  )
}

export async function getYourBenchmarkSummaryDataCtrl() {
  await getYourBenchmarkSummaryData()
}

export async function changeSurveyCleanerCtrl(surveyId, userId) {
  if (
    store.surveyTypeUrl === SurveyTypeURL.DB ||
    store.surveyTypeUrl === SurveyTypeURL.DC ||
    store.surveyTypeUrl === SurveyTypeURL.IBS
  ) {
    if (userId == null) {
      await changeDBSurveyCleanerFields(surveyId, null, null)
      return
    }

    let surveyCleanerString = null
    let cleanerObject = (ibsStore?.surveyCleanersIBS?.filter((cleaner) => {
      return cleaner.id === userId
    }) ?? [])[0]
    if (cleanerObject != null) {
      surveyCleanerString =
        (cleanerObject.firstName ?? '') +
        (cleanerObject.firstName != null && cleanerObject.lastName != null
          ? ' '
          : '') +
        (cleanerObject.lastName ?? '')
    }
    await changeDBSurveyCleanerFields(surveyId, userId, surveyCleanerString)
  } else {
    await changeSurveyCleaner(surveyId, userId)
  }
}

export async function changeSurveyStatusCtrl(surveyId, statusId) {
  if (
    store.surveyTypeUrl === SurveyTypeURL.DB ||
    store.surveyTypeUrl === SurveyTypeURL.DC ||
    store.surveyTypeUrl === SurveyTypeURL.IBS
  ) {
    await changeDBSurveyStatus(surveyId, statusId)
  } else {
    await changeSurveyStatus(surveyId, statusId)
  }
}
export async function getSurveyCleanersCtrl() {
    return await getSurveyCleaners();
}

export function addBenchmarkRow(assetClassId) {
  addBenchmarkPolicy(assetClassId)
}

export async function insertRowCtrl(
  assetClassId,
  styleId,
  tableName,
  catId = null
) {
  if (store.surveyTypeUrl === SurveyTypeURL.DB) {
    await addRowToTable(assetClassId, styleId, tableName, catId)
    //dc
  } else if (store.surveyTypeUrl === SurveyTypeURL.DC) {
    await insertEmptyRow(tableName)
  }
}

export async function deleteRowCtrl(rowId, tableName) {
  if (store.surveyTypeUrl === SurveyTypeURL.DB) {
    await deleteRowFromTable(rowId, tableName)
    //dc
  } else if (store.surveyTypeUrl === SurveyTypeURL.DC) {
    deleteRowFromTableDC(rowId, tableName)
  }
}

export async function getAssetStyleForAllCategories() {
  await getAssetStylesByCategory(1)
  await getAssetStylesByCategory(2)
  await getAssetStylesByCategory(3)
  await getAssetStylesByCategory(4)
  await getAssetStylesByCategory(5)
  await getAssetStylesByCategory(6)
  await getAssetStylesByCategory(7)
}

export async function getDbAssetStyles() {
  await GetAssetStylesDB()
  await GetDefaultCosts()
}

export function updateMandateInfoCtrl() {
  UpdateMandateInfo()
}

export function updateMandateInfoSingleCtrl(id, value, mandateId) {
  UpdateMandateInfoSingle(id, value, mandateId)
}

export function addMandateRowCtrl() {
  AddMandateRow()
}

export async function deleteMandateDataCtrl() {
  await deleteMandate()
}

export async function updateSurveyInfoCtrl(surveyId, fieldName, value, isDate) {
  await updateSurveyInfo(surveyId, fieldName, value, isDate)
}

export async function updatePlanInfoCtrl(surveyId, fieldName, value, isDate) {
    await updatePlanInfo(surveyId, fieldName, value, isDate)
}

export async function getIBSPlanResults() {
  if (SurveyTypeURL.DB == store.surveyTypeUrl) {
    await getParticipantResult()
    await getUniverseResult()
  } else if (SurveyTypeURL.DC == store.surveyTypeUrl) {
    await getDCResultsUniverse()
    await getDCResultsParticipant()
  }
}
